import { Location as NgLocation } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';

import { CwTab } from '@bbraun/cortex-angular';
import { TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';

import { ROUTES } from '../../../../definitions/constants/routes.constants';
import { SwitchViewData } from '../../../../definitions/interfaces/sidebars/switch-view-data';
import { SwitchOfflineUsersTabComponent } from '../switch-offline-users-tab/switch-offline-users-tab.component';
import { SwitchOnlineUsersTabComponent } from '../switch-online-users-tab/switch-online-users-tab.component';

@Component({
  selector: 'app-switch-view-sidebar-content',
  imports: [
    CwTab,
    SwitchOfflineUsersTabComponent,
    SwitchOnlineUsersTabComponent
  ],
  templateUrl: './switch-view-sidebar-content.component.html',
  styleUrl: './switch-view-sidebar-content.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchViewSidebarContentComponent {
  public primaryActionClicked = input.required<Subject<void>>();
  private readonly ngLocation = inject(NgLocation);
  private readonly translocoService = inject(TranslocoService);

  private readonly window = window;

  public currentActiveTab = signal('offline-customers');

  public isOfflineCustomersActive = computed(() => this.currentActiveTab() === 'offline-customers');
  public isOnlineCustomersActive = computed(() => this.currentActiveTab() === 'online-customers');

  public readonly switchUserTabs = [
    { title: this.translocoService.translate('Offline customers'), slot: 'offline-customers' },
    { title: this.translocoService.translate('Online customers'), slot: 'online-customers' },
  ];

  public onTabChange(event: CustomEvent<string>): void {
    this.currentActiveTab.set(event.detail);
  }

  public reloadPage(data: SwitchViewData): void {
    const queryString = `view=EXTERNAL&countryCode=${data.countryCode}&customerErpRef=${data.customerErpRef}`;

    if (data.reason) localStorage.setItem('access-reason', data.reason);

    this.ngLocation.go(ROUTES.REPLENISHMENT, queryString);
    this.window.location.reload();
  }
}
